import { Page, Text, View } from "@react-pdf/renderer";
import { ReactNode } from "react";

export default function PrintNewPage({
    children,
    orientation = "portrait",
}: {
    children: ReactNode;
    orientation?: "landscape" | "portrait";
    isStamped?: boolean;
}) {
    return (
        <Page
            size="A4"
            orientation={orientation}
            style={{
                paddingHorizontal: 20,
                paddingVertical: 0,
                height: "100%",
                fontSize: "8px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
            }}
        >
            <View>
                <View
                    style={{
                        width: "100%",
                        margin: 10,
                        height: 50,
                        backgroundColor: "#f0f0f0",
                        border: "2px dashed #cccccc",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Text style={{ fontSize: 10, color: "#999999" }}>
                        [Company Logo Placeholder]
                    </Text>
                </View>

                {children}
            </View>

            <View
                style={{
                    width: "100%",
                    margin: 10,
                    height: 50,
                    backgroundColor: "#f0f0f0",
                    border: "2px dashed #cccccc",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Text style={{ fontSize: 10, color: "#999999" }}>
                    [Company Logo Placeholder]
                </Text>
            </View>
        </Page>
    );
}
